import { render, staticRenderFns } from "./popup-content.vue?vue&type=template&id=b9f785a0&scoped=true&"
import script from "./popup-content.vue?vue&type=script&lang=js&"
export * from "./popup-content.vue?vue&type=script&lang=js&"
import style0 from "./popup-content.vue?vue&type=style&index=0&id=b9f785a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f785a0",
  null
  
)

export default component.exports